module.exports = __webpack_public_path__ + "3b69412bdceeec64d7acf4ef73f5d67e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sounds/oranje.mp3
// module id = 34
// module chunks = 0